<template>
  <div class="mc-dashboard__widget-item">
    <div class="mc-dashboard__widget-header d-flex justify-content-between">
      <div>
        <h4 class="font-size-16 teal-400 mb-1">
          {{ $t('dashboard.chart.top20Distance') }}
        </h4>
        <p class="font-size-10 teal-400 mb-0">
          {{ monthsPeriod }}
        </p>
      </div>
      <div>
        <b-form-radio-group
          id="btn-radios-1"
          v-model="selected"
          :options="radioGroupOptions"
          name="radios-btn-default"
          buttons
          button-variant="outline-primary"
          class="mc-btn--toggle"
        />
      </div>
    </div>
    <div class="mc-dashboard__widget-content-table-graph">
      <b-skeleton-wrapper :loading="localLoading">
        <template #loading>
          <b-row>
            <b-col md="12">
              <b-skeleton width="100%" height="295px" />
            </b-col>
          </b-row>
        </template>
        <template v-if="selected === 'tabel'">
          <div class="border border-1 table-overflow">
            <table class="table b-table table-sm">
              <thead>
                <tr>
                  <th>No</th>
                  <th>{{ $t('global.object.licensePlate') }}</th>
                  <th>{{ `${$t('dashboard.chart.usage')} (Km)` }}</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(data, index) in tripsStatistics?.aggregate?.top20TripMileage"
                  :key="index"
                >
                  <td>{{ index + 1 }}</td>
                  <td>{{ data.licensePlate }}</td>
                  <td>{{ thousandFormat(parseFloat(data.mileage / 1000).toFixed(2)) }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </template>

        <template v-else>
          <div class="mc-chart">
            <HorizontalBarChart
              :options="chartOptions"
              :labels="totalChartData.distance.labels"
              :datasets="totalChartData.distance.datasets"
            />
          </div>
        </template>
      </b-skeleton-wrapper>
    </div>
  </div>
</template>

<script>
import HorizontalBarChart from '@/components/Chart/HorizontalBar'
import { Helper } from '@/mixin/helper'

export default {
  components: { HorizontalBarChart },

  mixins: [Helper],

  props: {
    loading: {
      type: Boolean,
    },
    tripsStatistics: {
      type: Object,
    },
    period: {},
  },

  data() {
    return {
      selected: 'tabel',
      licensePlate: [],
      drivingDistance: [],
      monthsPeriod: '',
      localLoading: this.loading,
    }
  },

  computed: {
    tripsStatisticsIsReady() {
      return (
        this.tripsStatistics &&
        this.tripsStatistics.aggregate &&
        this.tripsStatistics.aggregate.top20TripMileage &&
        this.tripsStatistics.aggregate.top20TripMileage.length > 0
      )
    },
    chartOptions() {
      return {
        legend: { position: 'bottom', labels: { boxWidth: 0 } },
        scales: {
          xAxes: [
            {
              ticks: {
                beginAtZero: true,
                callback: (value) => {
                  if (Number.isInteger(value)) {
                    return value
                  }
                },
              },
            },
          ],
        },
      }
    },
    radioGroupOptions() {
      return [
        {
          html: `<i class="icon-outline_browser"></i><span>${this.$t(
            'report.object.table'
          )}</span>`,
          value: 'tabel',
        },
        {
          html: `<i class="icon-outline_bar-chart-2"></i><span>${this.$t(
            'report.object.chart'
          )}</span>`,
          value: 'grafik',
        },
      ]
    },

    totalChartData() {
      return {
        distance: {
          labels: this.licensePlate,
          datasets: [
            {
              data: this.drivingDistance,
              label: this.$t('dashboard.chart.totalDistance') + ' Km',
              backgroundColor: '#0d4491',
              barPercentage: 0.5,
            },
          ],
        },
      }
    },
  },

  watch: {
    tripsStatistics: {
      handler(newVal) {
        if (this.tripsStatisticsIsReady) {
          this.prepareChartData()
        }
      },
      immediate: true,
      deep: true,
    },
  },

  mounted() {
    if (this.tripsStatisticsIsReady) {
      this.prepareChartData()
    }
  },

  methods: {
    prepareChartData() {
      this.localLoading = true

      this.licensePlate = this.tripsStatistics?.aggregate?.top20TripMileage.map(
        (item) => item.licensePlate
      )

      this.drivingDistance = this.tripsStatistics?.aggregate?.top20TripMileage.map((item) =>
        parseFloat(item.mileage / 1000).toFixed(2)
      )

      const months = this.tripsStatistics?.data.map(
        (item) => `${this.localizeMonth(item.month)} ${item.year}`
      )
      this.monthsPeriod = `${months[0]} - ${months[2]}`

      setTimeout(() => {
        this.localLoading = false
      }, 500)
    },
  },
}
</script>
